import { Link } from "react-router-dom";


const Premiumpin = () => {
  return (
    <section>
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-1 text-end">
            <Link to="/">
              <h6>
                {" "}
                <i class="fa fa-home" aria-hidden="true"></i>Home
              </h6>
            </Link>
          </div>
          /
          <div className="col-lg-5">
            <h6>Premium Pin Request</h6>
          </div> */}

         

          <div className="col-lg-10 mt-3 mb-3">
            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>Premium Pin Request</h4>
              </div>

              <div className="card-body">
                <div className="col-lg-12 ">
                  <div className="row text-end">
                    <div className="col-lg-6"></div>
                    <div className="col-lg-3">
                      <label for="exampleInputPassword1" class="form-label">
                        Search:
                      </label>
                    </div>

                    <div className="col-lg-3">
                      <input
                        type="password"
                        class="form-control"
                        placeholder="Sponsor ID"
                        id="exampleInputPassword1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <div class="table-responsive">
                    <table class="table table-bordered  mb-0 text-nowrap">
                      <thead>
                        <tr>
                          <th> Sl.No </th>
                          <th>User ID</th>
                          <th>Name</th>
                          <th>Amount</th>
                          <th>Date</th>
                          <th>Transition ID </th>
                          <th>Upload Slip</th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>01</td>
                          <td>UI123</td>
                          <td>Rs 5000</td>
                          <td>WDM</td>
                          <td>qwer</td>
                          <td>WDM</td>
                          <td>qwer</td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-sm btn-warning"
                              data-toggle="modal"
                              data-target="#exampleModal"
                            >
                              History
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-2"></div>

          <div className="col-lg-6">
            <Link to="/basichistroy" className="btn btn-danger btn-md mt-2">
              Basic Pin Request History
            </Link>
          </div>
          <div className="col-lg-4"></div>
        </div>
      </div>
    </section>
  );
};

export default Premiumpin;
